import React from 'react';
import SelectBox from 'devextreme-react/select-box';

import {currencySymbols} from '../../../../configs';

/**
 * Dest signup currency widget: custom DevExtreme SelectBox with symbol overlay.
 * Closed: "(₺) TRY". Open: list of symbol + code with hover/selected highlight.
 */
const SignupCurrencyPicker = ({currencies, value, onChange}) => {
    const items = currencies ? Array.from(currencies) : [];

    return (
        <div className="signup__currencies-container">
            <div className="signup__currencies-symbol">
                ({currencySymbols[value]})
            </div>
            <SelectBox
                items={items}
                className="signup__currency-picker"
                showDropDownButton={false}
                openOnFieldClick={true}
                searchEnabled={false}
                value={value}
                onValueChanged={(e) => {
                    if (e.value && e.value !== value) {
                        onChange(e.value);
                    }
                }}
                itemRender={(code) => (
                    <span>
                        {currencySymbols[code]} {code}
                    </span>
                )}
                dropDownOptions={{
                    wrapperAttr: {class: 'signup__currency-dropdown'},
                    hideOnParentScroll: false,
                }}
            />
        </div>
    );
};

export default SignupCurrencyPicker;
